import type { Args as BaseArgs } from 'webapp/components/common/request-trial-base';
import CommonRequestTrialBaseComponent from 'webapp/components/common/request-trial-base';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class CommonRequestTrialButtonComponent<
	T extends BaseArgs,
> extends CommonRequestTrialBaseComponent<T> {
	<template>
		<SubmitButtonComponent
			@text={{this.text}}
			@extraClass="request-trial-button"
			@size={{@size}}
			@theme={{@theme}}
			@submitInProgress={{this.isRequestTrialInProgress}}
			@onTrigger={{this.requestTrial}}
		/>
	</template>
}
